import { withTheme } from 'theme';
import material3 from 'theme/material3';
import utils from 'utils';

const container = withTheme((theme) => ({
  ...utils.sx.container(theme),
  paddingTop: '6px',
  paddingBottom: '20px',
  [theme.breakpoints.down('md')]: {    
    maxWidth: '400px',
  }
}));

const textLayer = withTheme((theme) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(3),
  ...utils.sx.fw
}));

const btnsContainer = withTheme((theme) => ({
  width: '100%',
  maxWidth: 'none',
  [theme.breakpoints.up('md')]: {
    maxWidth: '330px'
  }
}));

const segmentButton = withTheme(() => ({
  ...utils.sx.fixedSize(120),
  borderRadius: material3.shape.medium,
  borderColor: material3.color.primary,
  color: material3.color.primaryDark,
  fontWeight: material3.typography.labelWeight,
  '&:hover': {
    backgroundColor: material3.color.primaryLight,
    borderColor: material3.color.primaryDark,
  }
}));

const styles = {
  container,
  textLayer,
  btnsContainer,
  segmentButton
};

export default styles;
